import { render } from "./Campaign.vue?vue&type=template&id=2eb70aae"
import script from "./Campaign.vue?vue&type=script&lang=js"
export * from "./Campaign.vue?vue&type=script&lang=js"
script.render = render

export default script